import type { CaseCardRecipe, ContactCardRecipe } from 'lib/cardRecipe'

const BOARD_CARD_FRAME = { className: `relative overflow-hidden px-3.5 py-3`, liftable: true }

/** Active Leads. No cue and no details line: both describe a patient's visit, and a lead has none yet. */
export const LEAD_CARD: ContactCardRecipe = {
  subject: `contact`,
  density: `comfortable`,
  frame: BOARD_CARD_FRAME,
  sections: [
    { kind: `nameRow` },
    { kind: `tags` },
    { kind: `chips` },
    { kind: `comms`, source: `lazy` },
    { kind: `bottom`, variant: `lead` },
  ],
}

/** Every other Action Center queue: Hygiene Recall's bands today. */
export const HYGIENE_CARD: ContactCardRecipe = {
  subject: `contact`,
  density: `comfortable`,
  frame: BOARD_CARD_FRAME,
  sections: [
    { kind: `nameRow` },
    { kind: `cue` },
    { kind: `tags` },
    { kind: `details` },
    { kind: `chips` },
    { kind: `comms`, source: `lazy` },
    { kind: `bottom`, variant: `hygiene` },
  ],
}

/** Unscheduled Treatment: a case, not a contact. */
export const CASE_CARD: CaseCardRecipe = {
  subject: `case`,
  density: `comfortable`,
  // The treatment board has not turned finger drag on, so a case stays natively draggable
  // on touch and carries no lift marker.
  frame: { className: `p-3.5`, liftable: false },
  sections: [{ kind: `caseHeader` }, { kind: `reasonBadge` }, { kind: `procedureGroups` }, { kind: `splitBar` }],
}
